<section class="enroll-card">
  <div class="enroll-card__copy">
    <h2 class="enroll-card__title">
      @if (completed()) {
        {{ 'app.parentLearning.enroll.completedTitle' | translate }}
      } @else if (joined()) {
        {{ 'app.parentLearning.enroll.joinedTitle' | translate }}
      } @else {
        {{ 'app.parentLearning.enroll.title' | translate }}
      }
    </h2>
    <p class="enroll-card__text">
      @if (completed()) {
        {{ 'app.parentLearning.enroll.completedText' | translate }}
      } @else if (joined()) {
        {{ 'app.parentLearning.enroll.joinedText' | translate }}
      } @else {
        {{ 'app.parentLearning.enroll.text' | translate }}
      }
    </p>
  </div>

  @if (!completed()) {
    <div class="enroll-card__actions">
      @if (joined()) {
        <app-parent-button
          variant="ghost"
          [loading]="leaveLoading()"
          (clicked)="leave.emit()"
        >
          {{ 'app.parentLearning.enroll.leave' | translate }}
        </app-parent-button>
      } @else {
        <app-parent-button
          variant="primary"
          [loading]="joinLoading()"
          (clicked)="join.emit()"
        >
          {{ 'app.parentLearning.enroll.join' | translate }}
        </app-parent-button>
      }
    </div>
  }
</section>
